module.exports = "https://cwa.roocdn.com/_next/static/apps.f69c41a1.svg";